import type { RegisteredTenantCreateOperation } from '@festina/configuration-general-types/configuration'
import { assertNotEmpty } from '@festina-life/core'

import type { OperationWithSourceInfo } from '../../uiModels/types'
import { useOperationsContext } from '../../workspace/operationsContext'
import { LocationAwareOperationLink } from '../configurationOperationLink/LocationAwareOperationLink'
import type { OperationsListVariant } from './types'

type Props = {
  operations: OperationWithSourceInfo<RegisteredTenantCreateOperation>[]
  variant: OperationsListVariant
}

export const RegisteredTenantOperations = ({ operations, variant }: Props) => {
  const { workspaceKey, branchKey } = useOperationsContext()

  // Currently the server isn't handling any errors for registered tenants so if we're hiding operations without errors,
  // we simply hide away all operations. This will be extended in the future to support error errors on tenants.
  return variant === 'errors'
    ? null
    : operations.map((createOperation) => {
        assertNotEmpty(createOperation.internalOperation.registeredTenant)

        const { tenantId, tenantName } =
          createOperation.internalOperation.registeredTenant

        assertNotEmpty(tenantId)
        assertNotEmpty(tenantName)
        assertNotEmpty(createOperation.internalOperation.operationKey)

        const operationName = `${tenantId}.${tenantName}`

        return (
          <LocationAwareOperationLink
            key={operationName}
            layer={createOperation.layer}
            block={createOperation.block}
            itemId={tenantId}
            itemLabel={tenantId}
            type="tenant"
            workspaceKey={workspaceKey}
            branchKey={workspaceKey?.branchKey ?? branchKey}
            operation={createOperation.internalOperation}
            operationKey={createOperation.internalOperation.operationKey}
            isLoading={false}
            isDraft={createOperation.isDraft}
          />
        )
      })
}
